/*
  Inventory details toggle (+/-) for the Quick Order List.

  Uses a SINGLE delegated click listener on `document`. This is required because
  the Quick Order List re-renders individual variant rows via AJAX after a cart
  update (see quick-order-list.js -> renderSections). Re-rendering replaces the
  edited row's innerHTML, destroying any listener bound directly to that row's
  + button. A delegated listener on `document` survives those re-renders because
  `document` is never replaced, so freshly rendered buttons keep working.

  The matching details row is located by id (data-details-variant-id matched to
  the button's data-variant-id) rather than by DOM sibling position, so it works
  even if row order shifts.

  Open/closed state is remembered per variant id. After an AJAX re-render brings
  a row back in its default (collapsed) state, we re-apply the open state so a
  panel that was open before the cart update stays open — no phantom extra click.
*/
(function () {
  if (window.__inventoryToggleDelegated) return;
  window.__inventoryToggleDelegated = true;

  // Set of variant ids whose inventory panel is currently open.
  var openVariantIds = new Set();

  function detailsRowsForVariant(variantId) {
    return document.querySelectorAll(
      '.inventory-details-row[data-details-variant-id="' + variantId + '"]'
    );
  }

  function toggleButtonsForVariant(variantId) {
    return document.querySelectorAll(
      '.inventory-toggle-btn[data-variant-id="' + variantId + '"]'
    );
  }

  function setOpenState(variantId, isOpen) {
    if (isOpen) {
      openVariantIds.add(variantId);
    } else {
      openVariantIds.delete(variantId);
    }

    detailsRowsForVariant(variantId).forEach(function (row) {
      row.classList.toggle('show', isOpen);
    });
    toggleButtonsForVariant(variantId).forEach(function (btn) {
      if (btn.hasAttribute('onclick')) return; // bulk-order-form buttons manage themselves
      btn.classList.toggle('active', isOpen);
      btn.textContent = isOpen ? '-' : '+';
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.inventory-toggle-btn');
    if (!btn) return;
    if (btn.hasAttribute('onclick')) return; // handled by bulk-order-form inline onclick
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    setOpenState(variantId, !openVariantIds.has(variantId));
  });

  // After the Quick Order List re-renders a row via AJAX, the fresh markup comes
  // back collapsed. Re-apply any remembered open state so the panel doesn't
  // silently close (which previously caused a confusing extra click).
  function restoreOpenState() {
    if (openVariantIds.size === 0) return;
    openVariantIds.forEach(function (variantId) {
      // Only restore if the row still exists in the DOM.
      if (detailsRowsForVariant(variantId).length) {
        setOpenState(variantId, true);
      } else {
        openVariantIds.delete(variantId);
      }
    });
  }

  function observe() {
    var container =
      document.querySelector('quick-order-list') ||
      document.querySelector('.quick-order-list-container') ||
      document.body;
    if (!container) return;

    var scheduled = false;
    var mo = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      // Coalesce bursts of mutations into a single restore pass.
      requestAnimationFrame(function () {
        scheduled = false;
        restoreOpenState();
      });
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
